<template>
  <!-- <q-card class="productcard" v-if="scrollPos||true"> -->
  <q-card class="productcard" @scroll="showing = false">
    <div class="productcard-corner-tag" v-if="isInCart" />
    <div class="edit-corner" v-if="currentAccount && currentAccount.isAdmin">
      <q-btn flat round color="primary" icon="edit" :to="`/admin/products/${product.id}`"/>
    </div>
    <div class="productcard-tag-new">
      <q-badge
        class="customBadge"
        color="blood"
        label="Back in stock"
        v-if="isBackInStock"
      ></q-badge>
      <q-badge
        class="customBadge"
        color="blood"
        label="I'm new here"
        v-if="isNew"
      ></q-badge>
    </div>

    <q-img v-if="productAttribute('manufacturer') == 'ICP.'" :src="imageUrlThumb || 'https://cdn.quasar.dev/img/parallax2.jpg'" @click="openProductDetails(product.id); trk_click_on_image()" class="full-width" native-context-menu > </q-img>
    <q-img v-else :src="imageUrlThumb || 'https://cdn.quasar.dev/img/parallax2.jpg'" @click="$store.commit('setSelectedProductId', product.id); trk_click_on_image()" class="full-width" native-context-menu > </q-img>


    <div style="margin:0">
      <div style="text-align: right; margin-right: 20px" class="text-grey">
        {{ formattedPrice }}
      </div>
    </div>    

    <div style="overflow: hidden; line-height: 1.1; padding:0px 15px; min-height:45px; max-height:45px" class="col text-h6">
     {{ product.name }}
    </div>

    <q-card-section class="row no-wrap items-center q-pa-none q-pl-md">
      <div class="col text-h7 ellipsis">
        {{ productAttribute("brand") }}・{{ productAttribute("range") }}・{{
          productAttribute("material")
        }}
      </div>
    </q-card-section>

    <q-card-actions class="full-width col-auto q-pb-none">
      <q-btn
        flat
        icon="add_shopping_cart"
        label="Add to cart"
        color="primary"
        v-if="this.cart && availableSkus.length"
        @click="trk_add_to_cart()"
      >
        <q-menu :offset="[80, 10]" scroll-target="body" v-model="showing" @scroll="showing = false">
          <q-list style="min-width: 320px">
            <q-layout view="Lhh lpR fff" container class="bg-white" style="width:320px; overflow:hidden" :style="{'height':calHeight(availableSkus)}">
              <q-header class="bg-white text-black">
                <div class="row" style="padding-top:5px"> 
                  <div class="text-center" :style="{'width':colourWidth}">Colour</div>
                  <div class="text-center"  style="width:45px" v-if="!isContainerType">Stock</div>
                  <div class="text-center"  style="width:100px">Cart</div>
                </div>
              </q-header>

              <q-page-container  style=" overflow:hidden">
                <q-page style="overflow:hidden">
                  <q-item v-for="(sku,index) in availableSkus" :key="index">
                    <q-item-section  style="overflow:hidden">
                      <div class="row" style="width:320px; overflow:hidden">
                        <div :style="{'width':colourWidth}">
                          <div :style="{ border: '1px silver solid', backgroundColor: sku.options.colour.hex, width: '10px', height: '10px', marginRight: '5px', }" class="inline-block" ></div>
                          <span v-if="!isHardware(product)">
                          {{ sku.options.colour.group }} {{ sku.options.colour.name }}
                          </span>
                          <span v-else>Hardware</span>
                        </div>
                        <div class="text-center" style="width:45px" v-if="!isContainerType">
                        {{getAvailableQty(sku)}}
                        </div>             
                        <div  style="width:100px" >
                          <q-input  
                          :min="0" 
                          :max="maxStockForItem(sku)"
                            :value="getQtyInCart(sku.id)"
                            @input="v => updateBasketWithLimit(sku, v)" 
                            debounce="1000" id="cu" class="cui" maxlength="5" dense outlined input-style="font-weight:bold; text-align:center; width:40px;  margin-left: -5px; margin-right:-50px; padding: 0"  >
                          
                            <template v-slot:prepend>
                              <q-btn  @click="removeOne(sku)" class="minusButton" size="10px" color="black" stretch  flat icon="remove" style="width: 25px; height: 30px; margin-left: -12px" />
                            </template>
                            <template v-slot:append>
                              <q-btn   @click="addOne(sku)" class="plusButton" size="10px" color="black" stretch  flat icon="add" style="width: 25px; height: 30px; margin-right: -12px" />
                            </template>
                          </q-input>
                        </div>
                      </div>
                    </q-item-section> 
                  </q-item>
                </q-page>  
              </q-page-container>
            </q-layout>
          </q-list>
        </q-menu>
      </q-btn>
    </q-card-actions>
  </q-card>
</template>

<script>
import gql from "graphql-tag";
import moment from "moment";
import store from '../store';
import { properCase } from "../util/string";


export default {
  name: "ProductCard",
  props: {
    product: Object,
    storeType: String,
    value: Number,
    scrollInfo: Object,
  },
  directives: {
    init: {
      bind: function (el, binding, vnode) {
        vnode.context[binding.arg] = binding.value;
      },
    },
  },
  data() {
    return {
      itemSelectedQty: this.value,
      colourWidth: '135px',
      showing:false,
      currentPosition:0
    };
  },
  apollo: {
    cart() {
      return {
        query: gql`
          query cart($id: ID!) {
            cart(id: $id) {
              id
              items {
                id
                skuId
                qty
                sku {
                  id
                  options
                  product {
                    id
                    name
                    attributes
                  }
                }
              }
            }
          }
        `,
        variables() {
          return {
            id: this.cartId,
          };
        },
        context: {
          headers: {
            uuid: this.currentUUID,
          },
        },
        // skip () {
        //   return this.currentAccount
        // },
        fetchPolicy: "network-only",
      };
    },
  },
  computed: {
    // scrollPos(){
    //   if(this.showing && this.currentPosition != this.scrollInfo.position){
    //     this.showing = false;
    //     this.currentPosition = 0;
    //   }
    // },
    currentUUID() {
      return this.$store.state.auth.currentUUID;
    },
    isContainerType() {
      if(this.storeType === "container"){
        this.colourWidth = '180px'
        return true;
      }else{
        return false;
      }
    },
    cartId() {
      if (this.storeType === "stock") {
        return this.$store.state.auth.currentAccount?.activeCartId;
      } else if (this.storeType === "container") {
        return this.$store.state.auth.currentAccount?.activeContainerCartId;
      } else if (this.storeType === "retail") {
        if (!!this.currentAccount) {
          return this.$store.state.auth.currentAccount?.activeRetailCartId;
        } else {
          return this.$store.state.auth.currentGuest.activeRetailCartId;
        }
      }
      console.error(`Unknown storeType for ProductDialog: ${this.storeType}`);
      return "";
    },
    currentAccount() {
      return this.$store.state.auth.currentAccount;
    },
    filters() {
      return this.$store.state.filters.filters;
    },
    colourFilter() {
      return this.filters?.find?.((filter) => filter.type === "colour");
    },
    formattedPrice() {
      if (!this.product.skus.length) return "Out of stock";
      const priceFieldName = {
        container: "containerPrice",
        retail: "retailPrice",
        stock: "price",
      }[this.storeType];
      const prices = this.product.skus.map((p) => Number(p[priceFieldName]));
      const pMin = Math.min(...prices).toFixed(2);
      const pMax = Math.max(...prices).toFixed(2);
      if (pMin === pMax) return `$${pMin}`;
      else return `$${pMin} - $${pMax}`;
    },
    availableSkus() {
      const colourFilteredSkus = this.colourFilter
        ? this.product.skus.filter(
            (sku) =>
              sku.options?.colour &&
              this.colourSelectedInColourFilter(sku.options?.colour?.name)
          )
        : this.product.skus;
      if (this.storeType === "container") return colourFilteredSkus;
      return colourFilteredSkus.filter(
        (sku) => sku.stock - this.getQtyInCart(sku.id)
      );
    },
    isInCart() {
      return this.product?.skus?.some((sku) => !!this.getQtyInCart(sku.id));
    },
    isNew() {
      return this.getIsNew();
    },
    isBackInStock() {
      if (this.storeType === "stock" || this.storeType === "retail") {
        if (this.getIsNew()) return false;
        return this.product.skus.some((sku) =>
          moment().isBefore(
            moment(sku?.stockLastUpdate).add(
              global.config.showProductBackInStoreTagFor,
              "days"
            )
          )
        );
      }
    },
    imageUrl() {
      return this.product?.images?.[0]?.url;
    },
    imageUrlThumb() {
      return this.imageUrl + ".png.thumb";
    },
  },
  methods: {
    trk_add_to_cart(){     
      analytics.track("Clicked Add to Cart Button",{
        storeType: this.$store.state.cart.currentStoreType,
        product: this.product.name,
        product_details: this.product,
        where: "product grid"    
      });      
    },
    trk_click_on_image(){     
      analytics.track("Clicked Product Image",{
        storeType: this.$store.state.cart.currentStoreType,
        product: this.product.name,
        product_details: this.product,
        where: "product grid"    
      });      
    },    
    openProductDetails(pid){
      this.$router.push(`/productDetails/${pid}`)
    },
    setScrollPosition(){
      this.currentPosition = this.scrollInfo.position;
    },
    addOne(item) {
   
      let inBasket = Number(this.getQtyInCart(item.id));

      if (this.isContainerType) {
        inBasket++;
        this.updateBasket(item, inBasket);
        return;
      }

      if (inBasket + 1 <= item.stock) {
        inBasket++;
        this.updateBasket(item, inBasket);
      } else {
      }
    },
    removeOne(item) {
      let qty = Number(this.getQtyInCart(item.id));

      if (qty - 1 >= 0) {
        this.updateBasket(item, qty - 1);
      } else {
      }
    },
    updateBasketWithLimit(item, value){
      if(this.getQtyInCart(item.id) != value){
        if (this.isContainerType) {
          this.updateBasket(item, value);
          return;
        }else{
          if(value <= item.stock){
            this.updateBasket(item, value);
          }else{
            this.updateBasket(item, item.stock);
          }
        }
      }
    },
    calHeight(val){
      let itemQty = val.length;
      if(itemQty > 6){return '300px'}
      else {
        return `${(itemQty * 57)+28}px`
      }
      
    },
    /**
     * Checks if a colour is selected in the colour filter (if the filter exists)
     */
    isHardware(product) {
      let hardwareType = ["hardware", "climbing"];
      return (
        hardwareType.some((el) =>
          product.attributes.type.toLowerCase().includes(el)
        ) && product.skus.length == 1
      );
    },
    saveByEnter(btn_id) {
      document.getElementById(btn_id).click();
    },
    colourSelectedInColourFilter(colourName) {
      return !!this.colourFilter?.values?.find(
        (filterColour) => filterColour.name === colourName
      );
    },
    productAttribute(key) {
      return this.product?.attributes?.[key];
    },
    getAvailableQty(sku) {
      if (this.storeType === "container") return 10000;
      const available = sku.stock - this.getQtyInCart(sku.id);
      if (available < 0) return 0;
      return available;
    },
    getIsNew() {
      if (this.storeType === "container") {
        let currrentContainerDate = moment("2021-05-01"); //DummyDate: Needs to be replaced with the container open date
        let productDate = this.product.createdAt
          ? moment(this.product.createdAt)
          : moment(null);
        return currrentContainerDate.isValid() && productDate.isValid()
          ? productDate.diff(currrentContainerDate) >= 0
            ? true
            : false
          : false;
      }

      if (this.storeType === "stock" || this.storeType === "retail") {
        let productDate = this.product.createdAt
          ? moment(this.product.createdAt)
          : moment(null);
        return productDate.isValid()
          ? moment().isBefore(
              productDate.add(global.config.showNewProductTagFor, "days")
            )
          : false;
      }
    },
    getQtyInCart(skuId) {
      let vl = this.cart?.items?.find?.((item) => item.sku?.id === skuId)?.qty || 0;
      return vl
    },
    addSkuToCart(sku, qty) {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation addItemToCart($cartId: ID!, $input: CartItemInput!) {
              addItemToCart(id: $cartId, input: $input) {
                id
                name
                notes
                items {
                  id
                  skuId
                  qty
                  sku {
                    id
                    stock   
                    price
                    attributes
                    options
                    product {
                      id
                      name
                      images {
                        url
                        name
                      }
                      attributes
                      urlSlug
                    }
                  }
                }
              }
            }
          `,
          variables: {
            cartId: this.cartId,
            input: {
              skuId: sku?.id,
              qty,
            },
          },
          context: {
            headers: {
              uuid: this.currentUUID,
            },
          },
        })
        .then((result) => {
          const skuToSendToAnalytics = this.cart.items.find(
            (item) => item.skuId === sku?.id
          ).sku;
          // eslint-disable-next-line no-undef
          analytics.track("Add Item To Cart", {
            cartId: this.cartId,
            skuId: sku?.id,
            sku: skuToSendToAnalytics,
            qty,
            where: "product grid",
          });
          // this.$q.notify({
          //   message: `Added ${qty} ${sku?.options?.colour?.group} ${this.product?.name} to cart.`,
          //   icon: "done",
          //   color: "green",
          // });
        })
        .catch((err) => {
          this.$q.notify({
            message: "Error updating!",
            color: "negative",
            icon: "report_problem",
          });
        });
    },
    async updateBasket(sku, value) {
      // if (this.inputType === 'number') updatedValue = Number(updatedValue)
      // const input = { [this.field]: updatedValue }
      value = Number(value);
      try {
        if (
          value > 0 && !this.cart.items.find((item) => item.skuId === sku?.id)
        ) {
          await this.$apollo.mutate({
            mutation: gql`
              mutation addItemToCart($cartId: ID!, $input: CartItemInput!) {
                addItemToCart(id: $cartId, input: $input) {
                  id
                  items {
                    id
                    skuId
                    sku {
                      id
                      price
                      containerPrice
                      retailPrice
                      options
                      stock
                      product {
                        id
                      }
                    }
                    qty
                  }
                }
              }
            `,
            variables: {
              cartId: this.cart.id,
              input: {
                skuId: sku?.id,
                qty: value,
              },
            },
            context: {
              headers: {
                uuid: this.currentUUID,
              },
            },
          });
          // should search for sku in product!? - then add product under sku? - or add more depth to cart query...
          const skuToSendToAnalytics = this.cart.items.find(
            (item) => item.skuId === sku?.id
          ).sku;          
          // eslint-disable-next-line no-undef
          analytics.track("Add Item To Cart", {
            cartId: this.cartId,
            skuId: sku?.id,
            sku: skuToSendToAnalytics,
            qty: value,
            where: "Product Dialog",
          });
          // this.$q.notify({
          //   message: `Added ${value} ${sku?.options?.colour?.group} ${this.product?.name} to cart.`,
          //   icon: "done",
          //   color: "green",
          // });
        } else if (value === 0 && this.cart.items.find(item => item.skuId === sku?.id)) {
          await this.$apollo.mutate({
            mutation: gql`
              mutation deleteItemFromCart($cartId: ID!, $skuId: ID!) {
                deleteItemFromCart(id: $cartId, skuId: $skuId) {
                  id
                  items {
                    id
                    skuId
                    qty
                  }
                }
              }
            `,
            variables: {
              cartId: this.cart.id,
              skuId: sku?.id,
            },
            context: {
              headers: {
                uuid: this.currentUUID,
              },
            },
          });
          this.$store.commit(`cart/setCart${properCase(this.storeType)}Qty`, this.cart.items?.reduce((p, c, i) => p + Number(c.qty), 0));
          // eslint-disable-next-line no-undef
          analytics.track("Delete Item From Cart", {
            cartId: this.cartId,
            where: "product dialog",
            skuId: sku?.id,
          });
        } else if (this.cart.items.find(item => item.skuId === sku?.id)) {
          await this.$apollo.mutate({
            mutation: gql`
              mutation editItemInCart(
                $cartId: ID!
                $skuId: ID!
                $input: CartItemInput!
              ) {
                editItemInCart(id: $cartId, skuId: $skuId, input: $input) {
                  id
                  items {
                    id
                    skuId
                    qty
                  }
                }
              }
            `,
            variables: {
              cartId: this.cart.id,
              skuId: sku?.id,
              input: {
                qty: value,
              },
            },
            context: {
              headers: {
                uuid: this.currentUUID,
              },
            },
          });
          // eslint-disable-next-line no-undef
          analytics.track("Edit Item In Cart", {
            cartId: this.cart.id,
            skuId: sku?.id,
            updates: {
              qty: value,
            },
            where: "product dialog",
          });
          // this.$q.notify({
          //   message: `Quantity updated: ${value} ${sku?.options?.colour?.group} ${this.product?.name} changed on cart.`,
          //   icon: "done",
          //   color: "green",
          // });
        }
      } catch (err) {
        if (!err.message.includes("is not in cart")) {
          this.$q.notify({
            message: "Error updating!" + err.message,
            color: "negative",
            icon: "report_problem",
          });
        }
      }
      this.$store.commit(`cart/setCart${properCase(this.storeType)}Qty`, this.cart.items?.reduce((p, c, i) => p + Number(c.qty), 0));
    },
    maxStockForItem(props) {
      return (this.storeType || "").toLowerCase() === "container"
        ? 99999
        : props.stock;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
@import '~quasar-variables';

.productcard {
  @media (max-width: $breakpoint-xs) {
    width: 200px;
    height: 240px;
  }

  width: 260px;
  height: 390px;

  .q-img {
    @media (max-width: $breakpoint-xs) {
      width: 100px;
      height: 100px;
    }

    width: 250px;
    height: 250px;
    margin: 0 5px;
  }

  .text-h6.ellipsis {
    @media (max-width: $breakpoint-xs) {
      font-size: medium;
    }
  }

  .text-subtitle2 {
    @media (max-width: $breakpoint-xs) {
      font-size: small;
    }
  }

  .edit-corner {
    position: absolute;
    border-radius: 0px;
    float: right;
    width: 0px;
    height: 0px;
    border-style: solid;
    border-width: 0;
    margin: 345px 0 0 220px;
    border-color: $primary transparent transparent transparent;
    z-index: 99;
  }  

  .productcard-corner-tag {
    position: absolute;
    border-radius: 0px;
    float: left;
    width: 0px;
    height: 0px;
    border-style: solid;
    border-width: 14px 14px 0 0;
    border-color: $primary transparent transparent transparent;
    z-index: 99;
  }
 
  .customBadge {
    padding: 3px 6px;
    font-size: 14px;
    border: 2px solid #C5171C;
    color: #C5171C;
    background-color: white;
  }

  .productcard-tag-new {
    position: absolute;
    font-weight: bold;
    top: 10px;
    right: 10px;
    z-index: 99;
  }
}

  >>> .q-field{
    width: 92px
  }

  >>> .q-field__control {
    max-height: 30px;  
  }

  >>> .q-field__native {
    max-height: 30px;
  }

  >>> .q-field__control:after {
    max-height: 30px;
  }

  >>> .minusButton .q-icon {
    margin-left:-6px
    margin-top:2px
  }

  >>> .plusButton .q-icon {
    margin-left:-6px
    margin-top:2px
  }

</style>
